import React from "react";
import { Layout } from "antd";
import { HeartFilled } from "@ant-design/icons";

const { Footer: AntdFooter } = Layout;

const FooterComp = () => {
  return (
    <AntdFooter 
      style={{ 
        textAlign: "center",
        background: "rgba(255, 255, 255, 0.8)",
        backdropFilter: "blur(10px)",
        borderTop: "1px solid rgba(0, 0, 0, 0.06)",
        padding: "24px 16px",
      }}
      className="fade-in"
    >
      <div className="max-w-6xl mx-auto">
        <div className="flex flex-col md:flex-row items-center justify-between space-y-4 md:space-y-0">
          <div className="flex items-center space-x-2 text-gray-600">
            <span className="text-2xl">🤖</span>
            <div className="text-left">
              <div className="font-semibold text-gray-800">SIAM AI Monitoring System</div>
              <div className="text-sm">ระบบติดตามและรักษาความปลอดภัยอัจฉริยะ</div>
            </div>
          </div>
          
          <div className="text-center md:text-right">
            <div className="flex items-center justify-center md:justify-end space-x-1 text-gray-600">
              <span>Made with</span>
              <HeartFilled className="text-red-500 animate-pulse" />
              <span>by</span>
              <span className="font-semibold bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent">
                SIAM A.I. CO., LTD.
              </span>
            </div>
            <div className="text-sm text-gray-500 mt-1">
              © {new Date().getFullYear()} All rights reserved
            </div>
          </div>
        </div>
      </div>
    </AntdFooter>
  );
};

export default FooterComp;
